<template>
    <div class="editable-group-checkbox-list editable-groups-filters">
        <template v-if="editableGroupsFilterOptions.length">
            <CollapsibleWidget content-padding="none">
                <template #name>Content</template>

                <template #controls>
                    <Badge
                        v-if="countOfSelectedGroupValues > 0"
                        :count="countOfSelectedGroupValues"
                        class="filter-badge-count"
                    />
                </template>

                <div v-for="editableGroup in editableGroupsFilterOptions" :key="editableGroup.name">
                    <EditableGroupCheckbox
                        :group-name="editableGroup.name"
                        :label="editableGroup.label"
                        :options="editableGroup.options"
                    />
                </div>
            </CollapsibleWidget>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapStores } from "pinia";

import EditableGroupCheckbox from "@/components/Campaign/EditableGroupCheckbox.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

export default defineComponent({
    name: "EditableGroupCheckboxList",
    components: {
        CollapsibleWidget,
        EditableGroupCheckbox
    },

    computed: {
        ...mapStores(useCreativeLibraryFiltersStore),
        countOfSelectedGroupValues() {
            const selectedEditableIdsByGroup = this.creativeLibraryFiltersStore.selectedEditableIdsByGroup;
            return Object.values(selectedEditableIdsByGroup).reduce((count, ids) => count + ids.length, 0);
        },

        editableGroupsFilterOptions() {
            return this.$store.state.deliverableLibrary.filterOptions.editableGroups;
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.editable-group-checkbox-list {
    & > .ivu-collapse > .ivu-collapse-item-active .ivu-collapse-header {
        border-bottom: 1px solid $cmp-light-filters-border-color;
    }

    .collapsible-widget--small {
        &.ivu-collapse > .ivu-collapse-item {
            > .ivu-collapse-header {
                padding: 0 0 0 $spacing-large;
                border: none;

                &:hover {
                    background: $cmp-light-filters-hover-color;
                }
            }
        }
    }
}
</style>
